import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "title-block" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "modal-content" }

import { debounce } from "lodash";
  import {
    onMounted,
    onBeforeMount,
    reactive,
    nextTick,
    ref
  } from "vue";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: 'Popup',
  props: {
    title: { default: null },
    dataComponent: { default: null },
    zIndex: { default: 12 }
  },
  setup(__props: any, { expose: __expose }) {

  

  const props = __props;

  const state = reactive({
    isVisible: false,
    currentComponent: props.dataComponent,
    currentComponentProps: {},
    customScroll: null,
    modalWrapperHeight: null as number | null,
    modalHeight: null as number | null,
    titleResult: props.title
  });

  const auctionStore = useAuctionStore();

  const modalBlock = ref<HTMLDivElement | null>(null);
  const customScrollbarRef = ref<HTMLDivElement | null>(null);
  const modalTitle = ref<HTMLDivElement | null>(null);
  const resizeObserver = ref<ResizeObserver | null>(null);

  onMounted(() => {
    document.addEventListener("keydown", closeByEscapeKey);
    window.addEventListener("resize", debounce(windowResizeListener, 100));

    nextTick(() => {
      observeResize();
    });
  });

  onBeforeMount(() => {
    document.removeEventListener("keydown", closeByEscapeKey);
    window.removeEventListener("resize", windowResizeListener);
    unobserveResize();
  });

  const initCustomScroller = (refData) => {
    customScrollbarRef.value = refData.value.SimpleBar.el;
  };

  const open = () => {
    state.titleResult = props.title;
    state.isVisible = true;
    if (auctionStore.countOpenedModals < 1) {
      document.body.classList.add("overflow-hidden");
    }
    auctionStore.$patch({
      countOpenedModals: auctionStore.countOpenedModals + 1
    });
    changeModalContentHeight();
  };
  const close = () => {
    state.isVisible = false;
    customScrollbarRef.value.style.height = "";
    if (auctionStore.countOpenedModals <= 1) {
      document.body.classList.remove("overflow-hidden");
    }
    auctionStore.$patch({
      countOpenedModals: auctionStore.countOpenedModals - 1
    });
  };
  const closeByEscapeKey = (event: Event) => {
    if (event.keyCode === 27) {
      close();
    }
  };
  const toggleComponent = (component, props = {}) => {
    state.currentComponentProps = props;
    state.currentComponent = component;
  };
  const changeTitle = (titleNew: string) => {
    state.titleResult = titleNew;
  };
  const changeModalContentHeight = () => {
    getModalWrapperHeight();
    const modalScrollHeight = modalBlock.value.scrollHeight;

    if (modalScrollHeight > state.modalHeight) {
      customScrollbarRef.value.style.height = state.modalHeight - state.modalWrapperHeight + "px";
    }
  };
  const observeResize = () => {
    resizeObserver.value = new ResizeObserver((entries) => {
      for (let entry of entries) {
        state.modalHeight = entry.target.clientHeight;
        changeModalContentHeight();
      }
    });

    resizeObserver.value.observe(modalBlock.value);
  };
  const unobserveResize = () => {
    if (resizeObserver.value) {
      resizeObserver.value.disconnect();
      resizeObserver.value = null;
    }
  };
  const getModalWrapperHeight = () => {
    const modalTitleHeight = modalTitle.value.clientHeight;
    const paddingTop = parseInt(window.getComputedStyle(modalBlock.value, null).getPropertyValue("padding-top"));
    const paddingBottom = parseInt(window.getComputedStyle(modalBlock.value, null).getPropertyValue("padding-bottom"));

    state.modalWrapperHeight = modalTitleHeight + paddingTop + paddingBottom;
  };
  const windowResizeListener = () => {
    setModalHeightAuto();
    state.modalHeight = modalBlock.value?.clientHeight || 0;
    changeModalContentHeight();
  };
  const setModalHeightAuto = () => {
    customScrollbarRef.value.style.height = "auto";
  };

  __expose({
    toggleComponent,
    open,
    changeTitle
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _withDirectives(_createElementVNode("div", {
      class: "modal-container",
      style: _normalizeStyle({ 'z-index': _ctx.zIndex + 1 })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal", _ctx.$attrs.class]),
        ref_key: "modalBlock",
        ref: modalBlock
      }, [
        _createElementVNode("div", {
          class: "modal-title",
          ref_key: "modalTitle",
          ref: modalTitle
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(state.titleResult), 1)
          ]),
          _createElementVNode("div", {
            class: "modal__close",
            onClick: close
          }),
          _renderSlot(_ctx.$slots, "before-content")
        ], 512),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(CustomScrollbar, {
            onScrollerComponent: initCustomScroller,
            class: "custom-scrollbar"
          }, {
            default: _withCtx(() => [
              (state.isVisible)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(state.currentComponent), _mergeProps({ key: 0 }, state.currentComponentProps, {
                    onCloseForm: close,
                    onChangeTitle: changeTitle,
                    onSetModalHeightAuto: setModalHeightAuto
                  }), null, 16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 2)
    ], 4), [
      [_vShow, state.isVisible]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "modal-overlay background-fill",
      onClick: close,
      style: _normalizeStyle({ 'z-index': _ctx.zIndex })
    }, null, 4), [
      [_vShow, state.isVisible]
    ])
  ]))
}
}

})